import React from 'react';
import { getMovies } from '../api/endpoints.js';
import { MoviesIcon } from '../components/icons.js';
import { CatalogListPage } from './CatalogListPage.js';

export function MoviesPage(): React.JSX.Element {
  return (
    <CatalogListPage
      title="Фильмы"
      icon={<MoviesIcon />}
      emptyDescription="Каталог фильмов сейчас пуст."
      fetchPage={getMovies}
    />
  );
}
